const _LOCALISATION_PATH = {
    rewe: '/resources/localisation/rewe_localisation.json',
    kaufland: '/resources/localisation/kaufland_localisation.json',
    muller: '/resources/localisation/muller_localisation.json',
    edeka: '/resources/localisation/edeka_localisation.json',
    netto: '/resources/localisation/netto_localisation.json',
    alle: '/resources/localisation/alle_localisation.json',
    budni: '/resources/localisation/budni_localisation.json',
    gluecksrad: '/resources/localisation/gluecksrad_localisation.json'
}

export default _LOCALISATION_PATH;